import {Pipe, PipeTransform} from '@angular/core';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';

@Pipe(
{
  name: 'Base64Seguro'
})

export class Base64SeguroPipe implements PipeTransform
{
  constructor(private sanitized: DomSanitizer)
  {
  }

  transform(bsae64: string): SafeHtml
  {
      return this.sanitized.bypassSecurityTrustUrl('data:image/jpg;base64,' + bsae64);
  }
}
